import { createSelector } from 'reselect';
import { initialState } from './reducer';
import { NAMESPACE } from './constants';

const selectInitWebchatDomain = state => state[NAMESPACE] || initialState;

const selectErrorCode = () =>
    createSelector(selectInitWebchatDomain, state => state.errorCode);

const selectLoading = () =>
    createSelector(selectInitWebchatDomain, state => state.loading);

const selectMessage = () =>
    createSelector(selectInitWebchatDomain, state => state.message);

export {
    selectErrorCode,
    selectLoading,
    selectMessage,
};
